//Loader Component

<template>
  <div v-if="isVisible" class="loader-overlay">
    <div class="loader">
      <pulse-loader
        :loading="loading"
        :color="color"
        :size="size"
      />
    </div>
    <span class="text" v-html="text"/>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
export default {
  name: "Loader",
  components: {
    PulseLoader,
  },
  props: {
    isVisible: { type: Boolean, required: true },
    text: { type: String, required: false, default: "" },
  },
  data() {
    return {
      loading: true,
      color: "#2561d9",
      size: "20px",
      margin: "10px",
      radius: "1px",
    };
  },
};
</script>

<style lang="scss">
.loader-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  cursor: pointer;
  span.text {
    display: inline-block;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
  }
  .loader {
    position: absolute;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
  }
}
</style>
